export const PRESETS = [
  {
    id: "shipped",
    label: "ส่งสินค้าแล้ว",
    title: "สินค้าถูกจัดส่งแล้ว",
    body: "คำสั่งซื้อ #DEMO-1001 ของคุณถูกจัดส่งเรียบร้อยแล้ว ขณะนี้พัสดุอยู่ระหว่างนำส่งโดยบริษัทขนส่ง สามารถติดตามสถานะล่าสุดได้จากหน้าเว็บไซต์",
  },
  {
    id: "repair-complete",
    label: "ซ่อม/เคลมเสร็จ",
    title: "ซ่อมสินค้าเรียบร้อยแล้ว",
    body: "รายการแจ้งซ่อม/เคลมเลขที่ CLM-1001 ดำเนินการเสร็จเรียบร้อยแล้ว กรุณาติดต่อเจ้าหน้าที่เพื่อนัดหมายรับสินค้า หรือตรวจสอบรายละเอียดเพิ่มเติมบนเว็บไซต์",
  },
  {
    id: "received",
    label: "ได้รับสินค้าแล้ว",
    title: "ได้รับสินค้าเรียบร้อยแล้ว",
    body: "ระบบบันทึกว่าคุณได้รับสินค้าสำหรับคำสั่งซื้อ #DEMO-1001 เรียบร้อยแล้ว หากพบปัญหาหรือสินค้าไม่ครบ กรุณาติดต่อฝ่ายบริการลูกค้าภายในระยะเวลาที่กำหนด",
  },
  {
    id: "out-for-delivery",
    label: "กำลังนำส่ง",
    title: "พัสดุกำลังนำส่ง",
    body: "พัสดุของคุณออกจากศูนย์กระจายสินค้าและกำลังนำส่งไปยังที่อยู่ปลายทาง โปรดเตรียมผู้รับและตรวจสอบโทรศัพท์เพื่อไม่พลาดการติดต่อจากพนักงานจัดส่ง",
  },
  {
    id: "more-information",
    label: "รอข้อมูลเพิ่ม",
    title: "กรุณาส่งข้อมูลเพิ่มเติม",
    body: "รายการซ่อม/เคลมของคุณยังไม่สามารถดำเนินการต่อได้ เนื่องจากต้องการรูปภาพหรือข้อมูลสินค้าเพิ่มเติม กรุณาเปิดเว็บไซต์เพื่อตรวจสอบรายการที่ต้องส่งให้เจ้าหน้าที่",
  },
  {
    id: "ready-for-pickup",
    label: "พร้อมรับที่สาขา",
    title: "นัดรับสินค้าได้แล้ว",
    body: "สินค้าของคุณพร้อมรับที่สาขาแล้ว กรุณานำหลักฐานคำสั่งซื้อและเอกสารยืนยันตัวตนมาแสดงภายในวันและเวลาทำการที่ระบุบนเว็บไซต์",
  },
] as const;

export type PresetId = (typeof PRESETS)[number]["id"];

export function getPreset(id: string) {
  return PRESETS.find((preset) => preset.id === id);
}
